import { typo } from 'components/filter-popover/styles';

export const styles = {
  tableRow: {
    position: 'relative',
    opacity: '0.7',

    '& .first': {
      zIndex: '2',
    },

    '&:hover .rowBackground': {
      border: '1px solid #4D6EF5',
    },

    '&:hover > .MuiTableCell-root': {
      background: '#FAFBFC',
    },

    '&:last-child': {
      '& .MuiTableCell-root': {
        borderBottom: 0,

        '& .rowBackground': {
          borderBottomLeftRadius: '12px',
          borderBottomRightRadius: '12px',
        },
      },
    },
  },
  tableFirstCellContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  tableCell: {
    ...typo,
    lineHeight: 1,
    padding: '0 16px',
    height: '48px',
    borderBottom: '1px solid #F3F4F9',
    borderRight: '1px solid #F3F4F9',
    whiteSpace: 'nowrap',

    '& .MuiTypography-root': {
      ...typo,
    },
    '&:last-child': {
      borderRight: 0,
    },
    '&.actions-wrapper': {
      width: '20px',
    },
  },
};
